import { RequestError } from '#errors/index.ts';
import type { TSseOpenOptions, TSseReconnect } from './sse.types.ts';

const EVENT_STREAM = 'text/event-stream';
const JSON_TYPE = 'application/json';
const NO_CONTENT = 204;

export const buildSseRequest = (
  { method, body, headers = {}, lastEventId }: TSseOpenOptions,
  signal: AbortSignal,
): RequestInit => {
  const hasBody = body !== undefined;

  return {
    method: method ?? (hasBody ? 'POST' : 'GET'),
    body: hasBody ? JSON.stringify(body) : undefined,
    headers: {
      Accept: EVENT_STREAM,
      ...(hasBody ? { 'Content-Type': JSON_TYPE } : {}),
      ...(lastEventId === undefined ? {} : { 'Last-Event-ID': lastEventId }),
      ...headers,
    },
    signal,
  };
};

export const isEventStream = (response: Response): boolean => {
  const contentType = response.headers.get('content-type');

  return Boolean(contentType?.startsWith(EVENT_STREAM));
};

export const isNoContent = (response: Response): boolean =>
  response.status === NO_CONTENT;

export const resolveReconnect = (
  client: TSseReconnect | undefined,
  call: TSseReconnect | false | undefined,
): TSseReconnect | undefined => (call === false ? undefined : (call ?? client));

export const isDrop = (cause: unknown): boolean =>
  cause instanceof RequestError && cause.detail.kind === 'network';
